module.exports = __webpack_public_path__ + "img/notesattachments.2908103c.png";